import { Injectable } from '@angular/core';
import { AppService } from '@suite/app.service';
import { LogonService } from '@common/services/logon-service';
import { ServiceResponse } from "@common/data-models/service/service-response";
import { IAuthService } from '@common/interfaces/i-auth.service';

@Injectable({providedIn: 'root'})
export class ENPSService implements IAuthService {
    constructor(public appService: AppService, private logonService: LogonService) { }

    public async authenticate(): Promise<ServiceResponse<void>> {
        return await this.loginWithToken();
    }

    public async loginWithToken(): Promise<ServiceResponse<void>> {
        let userNameChunks = [];
        let domain = '';
        let userNameToSend = this.logonService.username;
        if (this.logonService.username.indexOf('@') != -1) {
            userNameChunks = this.logonService.username.split('@');
            userNameToSend = userNameChunks[0];
            domain = userNameChunks[1];
        } else if (this.logonService.username.indexOf('\\') != -1) {
            userNameChunks = this.logonService.username.split('\\');
            userNameToSend = userNameChunks[1];
            domain = userNameChunks[0];
        }
        let res = await this.logonService.logon(userNameToSend, this.logonService.password, "", domain);
        if (!res.status && window["ANDROID_WRAPPER"] && window["ANDROID_WRAPPER"].loginFailed) {
            window["ANDROID_WRAPPER"].loginFailed();
        }
        return res;
    }

    public logout() {
        console.log("Logged out.");
        if (window["ANDROID_WRAPPER"]) window["ANDROID_WRAPPER"].logout();
    }
}
